import { queryOptions, useQuery } from '@tanstack/react-query';

import { QueryKeys } from '../keys';
import { request } from '../request';
import { conditionPdfSchema } from './schemas';

const conditionPdfQueryOptions = (id: number) =>
  queryOptions({
    queryKey: QueryKeys.conditions.pdf(id),
    queryFn: async () => {
      const response = await request(`/conditions/${id}/preview`);

      const { pdf } = conditionPdfSchema.parse(response);

      return pdf;
    },
    staleTime: Infinity,
  });

export const useConditionPdf = (id: number) => {
  return useQuery(conditionPdfQueryOptions(id));
};
